import script from "./NotarialActionDataView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotarialActionDataView.vue?vue&type=script&setup=true&lang=js"

import "./NotarialActionDataView.vue?vue&type=style&index=0&id=0ad4b7e2&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad4b7e2"]])

export default __exports__